// src/components/ShopPage.jsx
import React from "react";
import { useLocation, useParams } from "react-router-dom";
// import MainMenu from "./MainMenu.jsx";
import CollectionsGrid from "./CollectionsGrid.jsx";
import { useProductsQuery } from "../hooks/useProductsQuery.js";
import ProductSkeletonCard from "./ProductSkeletonCard.jsx";

function ShopPage() {
  const location = useLocation();
  const { collectionHandle } = useParams(); // /collections/:collectionHandle

  const queryParams = new URLSearchParams(location.search);
  const filterFromQuery = queryParams.get("filter");

  // Map URL collection handles to your internal filter keys
  const filterFromCollectionHandle = (handle) => {
    switch (handle) {
      case "all":
        return "all";
      case "bralettes":
        return "bras";
      case "knickers":
        return "knickers";
      case "swimwear":
        return "swim";
      case "double-denim-silk-pyjamas":
        return "clothing";
      case "accessories":
        return "accessories";
      case "personalised":
        return "personalised";
      default:
        return handle || "all";
    }
  };

  // Decide active filter
  const activeFilter =
    filterFromQuery || filterFromCollectionHandle(collectionHandle);

  const {
    data: products = [],
    isLoading,
    isError,
  } = useProductsQuery(activeFilter);

  if (isLoading) {
    return (
      <div>
        {/* <MainMenu /> */}
        <div className="mt-8 p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {Array.from({ length: 12 }).map((_, i) => (
              <ProductSkeletonCard key={i} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div>
        {/* <MainMenu /> */}
        <div className="mt-8 p-8">
          <p>Failed to load products. Please try again later.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* <MainMenu /> */}
      <CollectionsGrid filter={activeFilter} products={products} />
    </div>
  );
}

export default ShopPage;
